<nb-card>

  <nb-card-header class="d-flex justify-content-between align-items-center">

    <div>
      <div>📊 Historial de pagos -
        <small>
          {{ data.clientName }}
        </small>
      </div>
    </div>

    <button
      nbButton
      size="tiny"
      status="danger"
      (click)="close()">
      <mat-icon>close</mat-icon>
    </button>

  </nb-card-header>

  <nb-card-body>

    <div *ngIf="loading">
      Cargando...
    </div>

    <div
      *ngFor="
        let cycle of history;
        trackBy: trackByCycle
      "
      class="cycle-block">

      <div class="cycle-header">

        <div>

          <span *ngIf="!isCycleEditing(cycle.cycleId)">
            📅
            {{ cycle.startDate | date:'mediumDate':'UTC' }}
            -
            {{ cycle.endDate | date:'mediumDate':'UTC' }}
          </span>

          <div
            *ngIf="isCycleEditing(cycle.cycleId)"
            class="d-flex align-items-center">

            <input
              nbInput
              type="date"
              [ngModel]="cycle.startDate | date:'yyyy-MM-dd'"
              (ngModelChange)="cycle.startDate = $event">

            <span class="mx-2">
              →
            </span>

            <span>
              {{ calculateEndDate(cycle.startDate)
                  | date:'mediumDate':'UTC' }}
            </span>

          </div>

        </div>

        <div class="totals">
          💰 Pagado: ${{ cycle.totalPaid }}
        </div>

        <div class="cycle-actions">

          <button
            *ngIf="!isCycleEditing(cycle.cycleId)"
            nbButton
            size="tiny"
            status="info"
            (click)="toggleCycleEdit(cycle.cycleId)">
            Editar ciclo
          </button>

          <button
            *ngIf="isCycleEditing(cycle.cycleId)"
            nbButton
            size="tiny"
            status="success"
            (click)="saveCycle(cycle)">
            Guardar
          </button>

          <button
            *ngIf="isCycleEditing(cycle.cycleId)"
            nbButton
            size="tiny"
            status="danger"
            (click)="toggleCycleEdit(cycle.cycleId)">
            Cancelar
          </button>

          <button
            *ngIf="
              isCycleEditing(cycle.cycleId) &&
              cycle.status === 'activo' &&
              cycle.payments?.length === 0
            "
            nbButton
            size="tiny"
            status="danger"
            (click)="deleteCycle(cycle)">
            Eliminar ciclo
          </button>

        </div>

      </div>

      <table class="cycle-table">

        <thead>

          <tr>

            <th>Tipo</th>
            <th>Monto</th>
            <th>Estatus</th>
            <th>Número Factura</th>
            <th>Factura</th>
            <th>Comprobantes</th>
            <th>Notas</th>
            <th>Acciones</th>

          </tr>

        </thead>

        <tbody>

         <tr
          *ngFor="
            let p of cycle.payments;
            trackBy: trackByPayment
          ">

            <!-- TIPO -->
            <td>
              {{ p.type === 'extra' ? 'Excedente' : cycle.cycleType }}
            </td>

            <!-- MONTO -->
            <td>

              <div *ngIf="!isPaymentEditing(p._id)">
                ${{ p.monto }}
              </div>

              <input
                *ngIf="isPaymentEditing(p._id)"
                nbInput
                type="number"
                [(ngModel)]="p.monto"
                class="input-small">

              <div
                *ngIf="p.previousAmount && p.previousAmount !== p.monto"
                class="change-reason">

                <div class="change-amount">
                  {{ p.previousAmount }}
                  →
                  {{ p.monto }}
                </div>

                <div class="change-text">
                  {{ p.changeReason }}
                </div>

                <div
                  class="change-date"
                  *ngIf="p.priceChangedAt">
                  {{ p.priceChangedAt | date:'short':'UTC' }}
                </div>

              </div>

            </td>

            <!-- STATUS -->
            <td>

              <span
                *ngIf="!isPaymentEditing(p._id)"
                [ngClass]="getStatusClass(p.status)">
                {{ p.status }}
              </span>

              <select
                *ngIf="isPaymentEditing(p._id)"
                [(ngModel)]="p.status">

                <option value="pendiente">
                  Pendiente
                </option>

                <option value="pagado">
                  Pagado
                </option>

                <option value="facturado">
                  Facturado
                </option>

              </select>

            </td>

            <!-- FACTURA NUMBER -->
            <td>

              <span *ngIf="!isPaymentEditing(p._id)">
                {{ p.invoiceNumber || '—' }}
              </span>

              <input
                *ngIf="isPaymentEditing(p._id)"
                nbInput
                [(ngModel)]="p.invoiceNumber">

            </td>

            <!-- FACTURA -->
            <td>

              <ng-container *ngIf="p.invoiceFile?.url; else noFactura">

                <button
                  nbButton
                  size="tiny"
                  status="info"
                  (click)="viewFile(p.invoiceFile.url)">
                  Ver
                </button>

                <button
                  nbButton
                  size="tiny"
                  status="success"
                  (click)="downloadFile(
                    p.invoiceFile.url,
                    'factura'
                  )">
                  Descargar
                </button>

                <button
                  *ngIf="isPaymentEditing(p._id)"
                  nbButton
                  size="tiny"
                  status="warning"
                  (click)="uploadFile(p, 'Factura')">
                  Cambiar
                </button>

                <button
                  *ngIf="isPaymentEditing(p._id)"
                  nbButton
                  size="tiny"
                  status="danger"
                  (click)="removeInvoice(p)">
                  Eliminar
                </button>

              </ng-container>

              <ng-template #noFactura>
                <span *ngIf="!isPaymentEditing(p._id)">—</span>
              </ng-template>

              <div *ngIf="isPaymentEditing(p._id) && !p.invoiceFile?.url">
                <button
                  nbButton
                  size="tiny"
                  status="primary"
                  (click)="uploadFile(p, 'Factura')">
                  Subir
                </button>
              </div>

            </td>

            <!-- COMPROBANTES -->
            <td>

              <ng-container
                *ngIf="(!p.paymentProofFiles || p.paymentProofFiles.length === 0) && !isPaymentEditing(p._id)">
                —
              </ng-container>

              <div *ngIf="p.paymentProofFiles?.length">

                <div
                  *ngFor="
                    let file of p.paymentProofFiles;
                    let i = index
                  "
                  class="proof-item">

                  <button
                    nbButton
                    size="tiny"
                    status="info"
                    (click)="viewFile(file.url)">
                    Ver {{ i + 1 }}
                  </button>

                  <button
                    nbButton
                    size="tiny"
                    status="success"
                    (click)="downloadFile(
                      file.url,
                      'comprobante_' + (i + 1)
                    )">
                    Descargar
                  </button>

                  <button
                    *ngIf="isPaymentEditing(p._id)"
                    nbButton
                    size="tiny"
                    status="warning"
                    (click)="replaceProof(p, i)">
                    Cambiar
                  </button>

                  <button
                    *ngIf="isPaymentEditing(p._id)"
                    nbButton
                    size="tiny"
                    status="danger"
                    (click)="removeProof(p, i)">
                    Eliminar
                  </button>

                </div>

              </div>

              <div *ngIf="isPaymentEditing(p._id)" class="mt-1">
                <button
                  nbButton
                  size="tiny"
                  status="primary"
                  (click)="uploadFile(
                    p,
                    'Comprobante de pago'
                  )">
                  + Agregar Comprobante
                </button>
              </div>

            </td>

            <!-- NOTAS -->
            <td>

              <span *ngIf="!isPaymentEditing(p._id)">
                {{ p.notes || '—' }}
              </span>

              <textarea
                *ngIf="isPaymentEditing(p._id)"
                nbInput
                fullWidth
                rows="3"
                [(ngModel)]="p.notes">
              </textarea>

            </td>

            <!-- ACCIONES -->
            <td>

              <button
                *ngIf="!isPaymentEditing(p._id)"
                nbButton
                size="tiny"
                status="info"
                (click)="togglePaymentEdit(p._id)">
                Editar
              </button>

              <button
                *ngIf="isPaymentEditing(p._id)"
                nbButton
                size="tiny"
                status="success"
                (click)="savePayment(p)">
                Guardar
              </button>

              <button
                *ngIf="isPaymentEditing(p._id)"
                nbButton
                size="tiny"
                status="danger"
                (click)="togglePaymentEdit(p._id)">
                Cancelar
              </button>

            </td>

          </tr>

        </tbody>

      </table>

    </div>

  </nb-card-body>

</nb-card>